import { OverviewChart } from 'components/Charts'
import { Header } from 'components/Header'
import { GradientCard, PrimaryContainer } from 'components/Sections'
import { StatisticsSection } from 'components/Statistics'
import { LabelSwitch } from 'components/Switch'
import { OverviewTable } from 'components/Table'
import _ from 'lodash'
import { useState } from 'react'
import useSWR from 'swr'
import { fetcher } from 'utils/fetcher'

const volumeColumns = ['Name', 'Total Volume']
const txCountColumns = ['Name', 'Total TX Count', 'Avg TX Size']

const Page = () => {
  const [showAggregatedVolume, setShowAggregatedVolume] = useState(false)
  const [showAggregatedTxCount, setShowAggregatedTxCount] = useState(false)
  const [showCumulativeVolume, setShowCumulativeVolume] = useState(false)
  const [showCumulativeTxCount, setShowCumulativeTxCount] = useState(false)

  const { data: volume, error: volumeError } = useSWR(
    'https://synapse.dorime.org/api/v1/analytics/volume/total',
    fetcher,
  )
  const { data: txCount, error: totalTxCountError } = useSWR(
    'https://synapse.dorime.org/api/v1/analytics/volume/total/tx_count',
    fetcher,
  )

  const previousVolumes = {}
  const volumeChartData = _.orderBy(
    _.map(volume?.data, (value, key) => {
      const { ...rest } = value
      _.map(rest, (value, key) => {
        if (previousVolumes[key]) {
          previousVolumes[key] += value
        } else {
          previousVolumes[key] = value
        }
      })

      const cumulativeOutput = {}
      if (showCumulativeVolume) {
        cumulativeOutput['date'] = key
        _.map(rest, (value, key) => {
          cumulativeOutput[key] = previousVolumes[key]
        })

        return cumulativeOutput
      }

      return { date: key, ...rest }
    }),
    'date',
  )

  const volumeTableData = _.orderBy(
    _.map(volume?.totals, (value, key) => {
      return { name: key, value: value }
    }),
    'value',
    'desc',
  )

  const txCountObject = {}
  const txCountTableObject = []
  _.map(txCount?.data, (dates, chain) => {
    _.map(dates, (value, key) => {
      if (key === 'total') {
        txCountTableObject.push({ name: chain, value: value })
      } else if (_.isObject(txCountObject[key])) {
        txCountObject[key][chain] = value
      } else {
        txCountObject[key] = { [chain]: value }
      }
    })
  })

  const txCountChartData = _.orderBy(
    _.map(txCountObject, (value, key) => {
      const { ...rest } = value
      const total = _.sum(_.values(rest))
      return { date: key, total, ...rest }
    }),
    'date',
  )

  const previousTxCounts = {}
  const newTxCountChartData = _.map(txCountChartData, (value, index) => {
    const { ...rest } = value

    _.map(rest, (value, key) => {
      if (key === 'date') {
        previousTxCounts[key] = value
      } else if (previousTxCounts[key]) {
        previousTxCounts[key] += value
      } else {
        previousTxCounts[key] = value
      }
    })

    const cumulativeOutput = {}
    if (showCumulativeTxCount) {
      console.log(rest)

      _.map(rest, (value, key) => {
        cumulativeOutput[key] = previousTxCounts[key]
      })

      return cumulativeOutput
    }

    return { ...rest }
  })

  _.map(txCountTableObject, (result, key) => {
    const { value, ...rest } = result
    txCountTableObject[key] = {
      ...rest,
      value,
      volume: volumeTableData[key]?.value,
      averageTxSize: volumeTableData[key]?.value / value,
    }
  })

  const txCountTableData = _.orderBy(txCountTableObject, 'value', 'desc')

  return (
    <div>
      <Header />
      <PrimaryContainer>
        <h1 className="mt-8 mb-8 text-4xl font-bold text-gray-200">Synapse Analytics</h1>
        <StatisticsSection />
        <div className="grid gap-4 mb-8 text-gray-200">
          <div>
            <GradientCard>
              <div className="flex justify-between">
                <h2 className="mb-2 text-2xl font-bold">Bridge Volume</h2>
                <div className="space-y-2">
                  <LabelSwitch
                    enabled={showAggregatedVolume}
                    setEnabled={setShowAggregatedVolume}
                    text="Show aggregated volume"
                  />
                  <LabelSwitch
                    enabled={showCumulativeVolume}
                    setEnabled={setShowCumulativeVolume}
                    text="Show cumulative volume"
                  />
                </div>
              </div>
              <OverviewChart data={volumeChartData} showAggregated={showAggregatedVolume} currency />
            </GradientCard>
          </div>
          <div>
            <GradientCard>
              <div className="flex justify-between">
                <h2 className="mb-2 text-2xl font-bold">Transaction Count</h2>
                <div className="space-y-2">
                  <LabelSwitch
                    enabled={showAggregatedTxCount}
                    setEnabled={setShowAggregatedTxCount}
                    text="Show aggregated transaction count"
                  />
                  <LabelSwitch
                    enabled={showCumulativeTxCount}
                    setEnabled={setShowCumulativeTxCount}
                    text="Show cumulative transaction count"
                  />
                </div>
              </div>
              <OverviewChart data={newTxCountChartData} showAggregated={showAggregatedTxCount} />
            </GradientCard>
          </div>
        </div>
        <div className="grid gap-8 mb-8 text-gray-200 xl:grid-cols-12">
          {volume && (
            <div className="xl:col-span-5">
              <h2 className="mb-4 text-2xl font-bold">Total Bridge Volume by Chain</h2>
              {<OverviewTable columns={volumeColumns} data={volumeTableData} currency></OverviewTable>}
            </div>
          )}
          {txCount && (
            <div className="xl:col-span-7">
              <h2 className="mb-4 text-2xl font-bold">Total Transaction Count by Chain</h2>
              <OverviewTable columns={txCountColumns} data={txCountTableData}></OverviewTable>
            </div>
          )}
        </div>
      </PrimaryContainer>
    </div>
  )
}

export default Page
